module.exports = __webpack_public_path__ + "static/img/08102832v3mx.5ed31d62.jpg";